/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export enum VodAssetType {
  FREE = "FVOD",
  SUBSCRIPTION = "SVOD",
  TRANSACTIONAL = "TVOD"
}
